// extracted by mini-css-extract-plugin
export default {"container":"style-module--container--e690c"};